module.exports = __webpack_public_path__ + "media/success_sound_classic.719dec2a.mp3";